import { useStores } from "../../core/stores/rootStore";
import React, { useContext, useEffect, useState,useRef } from "react";
import { useNavigate, useParams } from 'react-router-dom';
import { observer } from "mobx-react";
import { useTranslation, Trans } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { solid } from "@fortawesome/fontawesome-svg-core/import.macro";
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import Button from 'react-bootstrap/Button';
import Stack from 'react-bootstrap/Stack';
import Modal from 'react-bootstrap/Modal';
import Card from 'react-bootstrap/Card';
import Pagination from 'react-bootstrap/Pagination';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { StyledDropZone } from 'react-drop-zone'
import 'react-drop-zone/dist/styles.css'
import Skeleton from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'
import Placeholder from 'react-bootstrap/Placeholder';
import Container from 'react-bootstrap/Container';
import FormText from './../inputs/text';

import FormTextArea from './../inputs/textarea';

import FormSelect from './../inputs/select';
import FormDate from './../inputs/date';
import FormAutoComplete from './../inputs/autocomplete'
import FormSwitch from './../inputs/switch';
import FormFileUpload from "./../inputs/fileupload";
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { countries } from './../../countries'
import { getCurrencies } from './../../utils'
import { prepareForm } from './../../utils';

import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import Spinner from 'react-bootstrap/Spinner';

const EmailSettings = () => {

    let navigate = useNavigate();
    const { usersAdminStore, clientsStore, companiesStore, utilsStore, winbizStore } = useStores();
    const { searchCompany } = companiesStore;
    const { searchConsultant } = usersAdminStore;
    const { getCurrencies, currencies, updateEmailServer, getEmailServer, emailServer } = utilsStore;
    const { getById, client, reset, save } = clientsStore;
    const { config, getConfig, saveConfig } = winbizStore;
    
    const { t, i18n } = useTranslation();    
    const { id } = useParams();
    const [isLoading, setIsLoading] = useState(false);   
    const [validated, setValidated] = useState(false);
    const formRef = useRef(null);
    
    const [saving, setSaving] = useState(false);

    useEffect(() => {        
        
        setIsLoading(true);
        Promise.all([getEmailServer()]).then(() => { setIsLoading(false); })      

    }, [getEmailServer]);

       
    const handleSubmit = (event) => {
        
        event.preventDefault();

        const form = event.currentTarget;
        if (form.checkValidity() === false) {
            event.preventDefault();
            event.stopPropagation();
        } else {            
            var formData = prepareForm(event, false);            
            setSaving(true);
            updateEmailServer(formData, () => {}).finally(() => { setSaving(false); });
        }

        setValidated(true);
    };

    const goToList = () => {
        navigate("/administration/")
    };
    
    return (       
        <Form noValidate validated={validated} onSubmit={handleSubmit} ref={formRef}>
            <Card>
                {/*JSON.stringify(company)*/}
                <Card.Body>
                    <div>                      
                        <Stack direction="vertical">
                            <Row>
                                <Col style={{ alignSelf: "center" }}  >                                    
                                    <b>{t('emailSettings')}</b>
                                </Col>                                    
                                <Col md="auto">
                                    <Button disabled={saving} className="btn btn-danger float-end" onClick={goToList} >{t('cancel')}</Button>
                                </Col>
                                <Col md="auto">
                                    <Button type="submit" disabled={saving}  className="btn btn-secondary float-end" >
                                        {t('save')}
                                        {saving && <span>&nbsp;&nbsp;&nbsp;&nbsp;
                                            <Spinner animation="border" role="status" size="sm" /> </span>}
                                    </Button>
                                </Col>
                            </Row>

                            <hr />

                            
                            <Row className="my-2">
                                <Col xs={3}>
                                    <FormText hidden isNumber id="id" type="number" object={emailServer} />
                                    <FormText required label={t("username")} id="username" isLoading={isLoading} object={emailServer} />
                                </Col>

                                <Col xs={3}>
                                    <FormText required label={t("password")} id="password" type="password" isLoading={isLoading} object={emailServer} />
                                </Col>

                                
                            </Row>

                            <Row className="my-2">                                                              
                                <Col xs={3}>
                                    <FormText required label={t("host")} id="host" isLoading={isLoading} object={emailServer} />
                                </Col>

                                <Col xs={3}>
                                    <FormText required type="number" label={t("port")} id="port" isLoading={isLoading} object={emailServer} />
                                </Col>
                            </Row>

                           

                        </Stack>

                    </div >

                </Card.Body>
            </Card>
        </Form>

    );
};

export default observer(EmailSettings);
